// AffiliatedUnitPage.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function AffiliatedUnitPage() {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch("/api/AffiliatedUnit")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch units");
        return res.json();
      })
      .then((data) => {
        setUnits(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{
      maxWidth: 1100,
      margin: "0 auto",
      padding: "2rem 1rem",
      marginTop: "80px",
      minHeight: "80vh"
    }}>
      <h2 style={{
        textAlign: "center",
        fontWeight: 800,
        fontSize: "2rem",
        marginBottom: "1.5em",
        letterSpacing: "0.03em"
      }}>
        VBKP( विद्याभारती खेलपरिषद्) <small style={{ fontWeight: 400, fontSize: "1.1rem" }}>Affiliated Units</small>
      </h2>

      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
      {loading ? (
        <p style={{ textAlign: "center" }}>Loading...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
            minWidth: "650px"
          }}>
            <thead>
              <tr style={{
                background: "#f7f7f7",
                fontWeight: 600,
                fontSize: "1rem"
              }}>
                <th style={{ padding: "12px 8px" }}>S.No.</th>
                <th style={{ padding: "12px 8px" }}>Unit</th>
                <th style={{ padding: "12px 8px" }}>Address</th>
                <th style={{ padding: "12px 8px" }}>Contact Detail</th>
              </tr>
            </thead>
            <tbody>
              {units.map((unit, idx) => (
                <tr key={idx} style={{
                  borderBottom: "1px solid #eee",
                  textAlign: "left"
                }}>
                  <td style={{ padding: "8px 8px" }}>{idx + 1}</td>
                  <td style={{ padding: "8px 8px", wordBreak: "break-word" }}>
                    <Link
                      to={`/kshetra/${encodeURIComponent(unit.remark)}`}
                      style={{ color: "#0073e6", textDecoration: "underline" }}
                    >
                      {unit.name}
                    </Link>
                  </td>
                  <td style={{ padding: "8px 8px", wordBreak: "break-word" }}>
                    {unit.address}
                  </td>
                  <td style={{ padding: "8px 8px", wordBreak: "break-word" }}>
                    {(unit.phone || "")}
                    {unit.phone && unit.mobile ? ", " : ""}
                    {(unit.mobile || "")}
                    <br />
                    {(unit.email || "")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AffiliatedUnitPage;
